/**
 *  EDAP events
 */

export const actionlocation = 'trending-module';

export const TRENDING_MODAL_CLOSE = {
  name: 'datePickerModal.close',
  data: {
    actionlocation
  }
};

export const TRENDING_DATED_SEARCH = {
  name: 'dated.search.submit',
  data: {
    actionlocation
  }
};

export const TRENDING_NODATED_SEARCH = {
  name: 'search.submit',
  data: {
    actionlocation
  }
};

export const TRENDING_NODATES_CLICK = ({ actionstate }) => ({
  name: 'datepicker.nodates.click',
  data: {
    actionlocation,
    actionstate
  }
});



// WEBPACK FOOTER //
// ./src/universal/components/Trending/TrendingModal/events.js